import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Divider, Stack, Paper, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

import LoginForm from "./LoginForm";
import ContinueWithGoogle from "./components/ContinueWithGoogle";

export default function LoginView() {
  const navigate = useNavigate();

  const handleGoogleSignIn = () => {
    const serverUrl = process.env.REACT_APP_API_URL;
    window.location.href = `${serverUrl}/auth/signin/google`;
  };

  const handleSignUp = () => {
    navigate("/register");
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: "100vh",
          padding: "40px 0",
        }}
      >
        {/* Login Card */}
        <Paper
          elevation={3}
          sx={{
            padding: { xs: 3, sm: 4 },
            borderRadius: 3,
            width: "100%",
            maxWidth: "500px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Sign In Header */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 3,
            }}
          >
            {/* Logo instead of Avatar for login form */}
            <Box sx={{ textAlign: "center", mb: 2 }}>
              <img
                src="/logo.png"
                alt="Podcast Assistant Logo"
                style={{
                  height: "80px",
                  width: "auto",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Typography
              component="h1"
              variant="h5"
              sx={{ fontWeight: 600, color: "text.primary" }}
            >
              Sign In
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 1, textAlign: "center" }}
            >
              Welcome back! Please sign in to your account
            </Typography>
          </Box>

          {/* Social Login */}
          <Box sx={{ mb: 3 }}>
            <ContinueWithGoogle onClick={handleGoogleSignIn} />
          </Box>

          {/* Divider */}
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
            <Divider sx={{ flexGrow: 1 }} />
            <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
              or continue with email
            </Typography>
            <Divider sx={{ flexGrow: 1 }} />
          </Stack>

          {/* Login Form */}
          <LoginForm />
        </Paper>

        {/* Footer Links */}
        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Typography variant="body2" color="text.secondary">
            Don't have an account?{" "}
            <Typography
              component="span"
              variant="body2"
              sx={{
                color: "primary.main",
                cursor: "pointer",
                fontWeight: 500,
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={handleSignUp}
            >
              Sign up
            </Typography>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}
